import React, { useState } from 'react';
import * as S from './styles';

export type IncreaseOrDecreaseProps = {
  getIncreaseValue?: (value: number) => undefined;
  getDecreaseValue?: (value: number) => undefined;
  onChange?: (value: number) => undefined;
  minValue?: number;
  value?: number;
};

export const IncreaseOrDecrease = ({
  getIncreaseValue,
  getDecreaseValue,
  onChange,
  minValue = -100,
  value: oldValue = 0
}: IncreaseOrDecreaseProps) => {
  const [value, setValue] = useState(oldValue)
  const handleIncrease = () => {
    const more = value + 1;

    setValue(more);
    getIncreaseValue && getIncreaseValue(more);
    onChange && onChange(more);
  }

  const handleDecrease = () => {
    const less = value <= minValue ? minValue : value - 1;

    setValue(less)
    getDecreaseValue && getDecreaseValue(less);
    onChange && onChange(less);
  }
  return (
    <S.DivContent>
      <S.Label>{value}</S.Label>
      <S.BtMore onClick={handleIncrease} />
      <S.BtLess onClick={handleDecrease} />
    </S.DivContent>
  )
}

export default IncreaseOrDecrease
